import { format, formatDistanceStrict, isValid } from 'date-fns';
import { it } from 'date-fns/locale';

/**
 * Formattazione delle date con date-fns (locale italiano).
 *
 * Hacker News espone i timestamp in secondi Unix: qui vengono convertiti e
 * resi leggibili. Tutte le funzioni accettano una data di riferimento
 * opzionale, così i test sono deterministici e non dipendono da "adesso".
 */

/**
 * Converte un timestamp Unix in secondi in un oggetto Date.
 *
 * @param {number} unixSeconds
 * @returns {Date|null} `null` se il valore non è una data valida
 */
export function fromUnix(unixSeconds) {
  if (!Number.isFinite(unixSeconds) || unixSeconds <= 0) return null;
  const date = new Date(unixSeconds * 1000);
  return isValid(date) ? date : null;
}

/**
 * Distanza in linguaggio naturale rispetto a una data di riferimento.
 *
 * @param {number} unixSeconds
 * @param {Date} [baseDate=new Date()] istante di riferimento
 * @returns {string} es. "3 ore fa" — stringa vuota se la data non è valida
 */
export function formatRelative(unixSeconds, baseDate = new Date()) {
  const date = fromUnix(unixSeconds);
  if (!date) return '';
  return formatDistanceStrict(date, baseDate, { locale: it, addSuffix: true });
}

/**
 * Data completa, usata come tooltip della card.
 *
 * @param {number} unixSeconds
 * @returns {string} es. "29 luglio 2026, 14:32"
 */
export function formatAbsolute(unixSeconds) {
  const date = fromUnix(unixSeconds);
  if (!date) return '';
  return format(date, "d MMMM yyyy', 'HH:mm", { locale: it });
}

/**
 * Data in formato ISO, usata nell'attributo `datetime` del tag `<time>`.
 *
 * @param {number} unixSeconds
 * @returns {string}
 */
export function toISO(unixSeconds) {
  const date = fromUnix(unixSeconds);
  return date ? date.toISOString() : '';
}
